import { createAction, props } from "@ngrx/store";

export type SearchPurchaseByTransaction = {
  transactionNo: number;
  transactionDate?: string;
};

// Load by transaction number
export const loadPurchaseByTransactionNo = createAction(
  "[Purchase Return] Load Purchase By Transaction No",
  props<{ payload: SearchPurchaseByTransaction }>()
);

export const loadPurchaseByTransactionNoSuccess = createAction(
  "[Purchase Return] Load Purchase By Transaction No Success",
  props<{ purchase: any }>()
);

export const loadPurchaseByTransactionNoFailure = createAction(
  "[Purchase Return] Load Purchase By Transaction No Failure",
  props<{ error: any }>()
);

// Supplier purchases paginated
export const loadSupplierPurchases = createAction(
  "[Purchase Return] Load Supplier Purchases",
  props<{
    supplierId: string;
    page: number;
    limit: number;
    financialYear?: string;
  }>()
);

export const loadSupplierPurchasesSuccess = createAction(
  "[Purchase Return] Load Supplier Purchases Success",
  props<{ data: any[]; total: number; page: number }>()
);

export const loadSupplierPurchasesFailure = createAction(
  "[Purchase Return] Load Supplier Purchases Failure",
  props<{ error: any }>()
);
